import { Files } from '@flatsy/types/Files'
import { FilesStatus } from '@flatsy/types/Files'

/**
 * @description check if a file as an error status (EXPIRED | UNREADABLE | NON_COMPLIANT)
 * @param file Files
 * @returns boolean
 */
export const isFileError = (file: Files): boolean => {
  const { status } = file
  if (status === FilesStatus.EXPIRED) {
    return true
  }
  if (status === FilesStatus.UNREADABLE) {
    return true
  }
  if (status === FilesStatus.NON_COMPLIANT) {
    return true
  }

  return false
}
